import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './pages/home/home.component';
import { SharedModule } from './shared/shared.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';


import { ModalComponent } from './components/dialogs/modal-reset-password/modal.component';
import { ComponentsModule } from './components/components.module';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import { clearMoney, currencyMask, formatMoney, formatMoneyText, getCode, numberFloat, stripCode } from './pipes/pipes.pipe';
import { HttpClientModule } from '@angular/common/http';
import { DatePipe } from '@angular/common';
import { CalculatorGuard } from './pages/calculator/guard/calculator.guard';
import { ApiService } from './services/api/api.service';

import { AngularWebStorageModule } from 'angular-web-storage';
import { WebcamModule } from 'ngx-webcam';
import { PdfViewerModule } from 'ng2-pdf-viewer';




@NgModule({

  declarations: [
    AppComponent,
    HomeComponent,
    ModalComponent,
    
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    BrowserAnimationsModule,
    ComponentsModule,
    MatAutocompleteModule,
    HttpClientModule,
    AngularWebStorageModule,
    WebcamModule,
    PdfViewerModule
  ],

  providers: [formatMoney, clearMoney, numberFloat, currencyMask, stripCode, getCode, DatePipe, CalculatorGuard,  ApiService],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
